<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:new="createHandler"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import ExchangeRateSet from "../../../components/settings/exchangerateset/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": ExchangeRateSet,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('recexchangerateset.editexchangeset'),
      pageTitleValue: "",
      formData: {},
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
      isDisabled: true,
      search: this.$route.params.search,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadExchangeRateSetHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/exchangerateset/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.formData.startdate = moment(vm.formData.startdate).format(
            "YYYY-MM-DD"
          );

          vm.formData.enddate = moment(vm.formData.enddate).format(
            "YYYY-MM-DD"
          );

          vm.formData.lockstaff = res.data.rec[0].lockstaff;
          vm.formData.userid = this.$store.getters.userId;
          this.loadExchangeRateSetDetailHandler(vm.formData.id);
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadExchangeRateSetDetailHandler(id) {
      const vm = this;

      this.$store.dispatch('get', {url: "/exchangeratesetd/" + id})
        .then((res) => {
          vm.formData.exchangeratedetail = res.data.rec;

          for (let i = 0; i < vm.formData.exchangeratedetail.length; i++) {
            if (vm.formData.exchangeratedetail[i].canreverse == "Y") {
              vm.formData.exchangeratedetail[i].canreverse = 1;
              vm.formData.exchangeratedetail[i].canreversedesc = "Y";
            } else {
              vm.formData.exchangeratedetail[i].canreverse = 0;
              vm.formData.exchangeratedetail[i].canreversedesc = "N";
            }
          }

          for (let i = 0; i < vm.formData.exchangeratedetail.length; i++) {
            Object.assign(vm.formData.exchangeratedetail[i], { action: 2 });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/exchangerateset/" + vm.formData.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "exchangeratesetlist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "exchangeratesetlist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:
            "/exchangerateset/" +
            vm.formData.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "exchangeratesetlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "exchangeratesetnew" });
    },
  },

  async mounted() {
    await this.loadExchangeRateSetHandler();
  },
};
</script>